__turbopack_context__.v({
  "h1": "Editor-module__7MbI3W__h1",
  "textBox": "Editor-module__7MbI3W__textBox",
  "textBoxInner": "Editor-module__7MbI3W__textBoxInner",
});
